import { TextLength } from '.'
import { durationFromText, durationToText } from '../utils/number/duration'
import { fileSizeFromText, fileSizeToText } from '../utils/number/file-size'
import { timeFromText, timeToText } from '../utils/number/time'

export const numberFormats = ['duration', 'filesize', 'time'] as const

type NumberFormat = typeof numberFormats[number]

export function displayTextToNumber(text: string, format: NumberFormat): number {
    switch (format) {
        case 'duration':
            return durationFromText(text)
        case 'filesize':
            return fileSizeFromText(text)
        case 'time':
            return timeFromText(text)
    }
}

export function numberToDisplayText(number: number, format: NumberFormat, length: TextLength = 'display'): string {
    switch (format) {
        case 'duration':
            return durationToText(number, length)
        case 'filesize':
            return fileSizeToText(number, length)
        case 'time':
            return timeToText(number, length)
    }
}

export default NumberFormat
